import React, { useEffect, useState } from 'react';
import { ZapIcon } from 'lucide-react';
const TOTAL_SECONDS = 23 * 3600 + 59 * 60 + 54;
function pad(value: number): string {
  return value.toString().padStart(2, '0');
}
export function CountdownBar() {
  const [remaining, setRemaining] = useState<number>(TOTAL_SECONDS);
  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(prev => prev <= 1 ? TOTAL_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const units = [{
    value: Math.floor(remaining / 3600),
    suffix: 'Std'
  }, {
    value: Math.floor(remaining % 3600 / 60),
    suffix: 'Min'
  }, {
    value: remaining % 60,
    suffix: 'Sek'
  }];
  return <div className="sticky top-0 z-50 w-full bg-brand text-white" data-id="element-37" data-mp="28fe060fkp9gh">
      <div className="mx-auto flex max-w-5xl items-center justify-center gap-x-2 whitespace-nowrap px-4 py-1.5 text-[10px] font-bold uppercase tracking-[0.1em] sm:gap-x-2.5 sm:py-2 sm:text-xs sm:tracking-[0.14em]" data-id="element-38" data-mp="aoujk5uymidu">
        <ZapIcon className="h-3 w-3 shrink-0 fill-white sm:h-3.5 sm:w-3.5" aria-hidden="true" data-id="element-39" data-mp="13eag0335sph3" />
        <span data-id="element-40" data-mp="18cu2c4lo039z">Start-Angebot endet in:</span>
        <span className="flex items-center gap-1 tabular-nums" aria-live="off" data-id="element-41" data-mp="18eomvht0xtdj">
          {units.map((unit, index) => <span key={unit.suffix} className="flex items-center gap-0.5" data-id="element-42" data-mp="uff88mkgv7bo" data-mpi={index}>
              <span className="text-[11px] font-extrabold sm:text-base" data-id="element-43" data-mp="yffw0xtgguve">{pad(unit.value)}</span>
              <span className="text-[9px] normal-case tracking-normal opacity-90" data-id="element-44" data-mp="1m5thu6lg5xhj">{unit.suffix}</span>
              {index < units.length - 1 && <span className="px-0.5 opacity-70" data-id="element-45" data-mp="1r5fry75zaxm4">:</span>}
            </span>)}
        </span>
      </div>
    </div>;
}